import PropTypes from 'prop-types'
import React from 'react'
import { Redirect } from 'react-router-dom'
import {
  getPropertyIdForExternalReference,
  getPropertyIdForMaxImmoId,
  getPropertyIdForWhiseId,
} from '../services/networkService'
import PropertyNotFoundView from './PropertyNotFoundView'
import { buildRedirectTarget } from '../utils/domainRedirect'

class ExternalReferenceView extends React.PureComponent {
  state = {
    redirectUrl: null,
    error: null,
  }

  async componentDidMount() {
    if (this.props.match && this.props.match.params) {
      try {
        const subdomainFromQueryParams = new URLSearchParams(window.location.search).get('subdomain')
        const subdomain = subdomainFromQueryParams

        const { reference } = this.props.match.params

        let response = undefined
        switch (this.props.type) {
          case 'extref':
            response = await getPropertyIdForExternalReference(subdomain, reference)
            break

          case 'omnicasa':
            response = await getPropertyIdForExternalReference(subdomain, reference, 'omnicasa')
            break

          case 'maximmo':
            response = await getPropertyIdForMaxImmoId(subdomain, reference)
            break

          case 'sweepbright':
            response = await getPropertyIdForExternalReference(subdomain, reference, 'sweepbright')
            break

          case 'whise':
            response = await getPropertyIdForWhiseId(subdomain, reference)
            break

          case 'zabun':
            response = await getPropertyIdForExternalReference(subdomain, reference, 'zabun')
            break

          case 'skarabee':
            response = await getPropertyIdForExternalReference(subdomain, reference, 'skarabee')
            break

          default:
            break
        }

        if (!response || !response.data) {
          this.setState({ error: new Error('No response data') })
          return
        }

        const {
          data: { id: propertyId, isRentMatch },
        } = response

        if (!propertyId) {
          this.setState({ error: new Error('Property ID not found in response') })
          return
        }

        const path = isRentMatch ? `/property/${propertyId}/rentmatch/intro` : `/property/${propertyId}`
        const target = buildRedirectTarget(isRentMatch, path)

        if (target.type === 'absolute') {
          // Cross-domain: swap brand domain and do a full browser redirect
          window.location.href = target.url
        } else {
          // Same-domain: let React Router handle it
          this.setState({ redirectUrl: target.url })
        }
      } catch (error) {
        this.setState({ error })
      }
    }
  }

  render() {
    if (this.state.redirectUrl) {
      return <Redirect to={this.state.redirectUrl} />
    }

    if (this.state.error) {
      return <PropertyNotFoundView error={this.state.error} />
    }

    return <div>loading...</div>
  }
}

ExternalReferenceView.propTypes = {
  type: PropTypes.string,
  match: PropTypes.any,
  setUrl: PropTypes.func,
}
export default ExternalReferenceView



// WEBPACK FOOTER //
// ./src/views/ExternalReferenceView.js